import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_BUDGET,
  DELETE_BUDGET,
  UPDATE_BUDGET,
  ADD_NEW_BUDGET,
} from "./actionType";

import {
  getBudgetSuccess,
  getBudgetFail,
  deleteBudgetSuccess,
  deleteBudgetFail,
  updateBudgetSuccess,
  updateBudgetFail,
  addBudgetSuccess,
  addBudgetFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveBudgetApi,
  getBudgetApi,
  updateBudgetApi,
  deleteBudgetApi,
  addNewBudgetApi
} from "../../helpers/backend_helper";

function* getBudget({ payload: budget }) {
  try {
    const response = yield call(getBudgetApi, budget);
    yield put(getBudgetSuccess(GET_BUDGET, response.data));
  } catch (error) {
    yield put(getBudgetFail(GET_BUDGET, error));
  }
}

function* onUpdateBudget({ payload: budget }) {
  try {
    if (budget.setApprove) {
      const response = yield call(approveBudgetApi, budget);
      yield put(updateBudgetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateBudgetApi, budget);
      yield put(updateBudgetSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteBudget({ payload: budget }) {
  try {
    const response = yield call(deleteBudgetApi, budget);
    yield put(deleteBudgetSuccess({ budget, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewBudget({ payload: budget }) {
  try {
    const response = yield call(addNewBudgetApi, budget);
    yield put(addBudgetSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addBudgetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetBudget() {
  yield takeEvery(GET_BUDGET, getBudget);
}

export function* watchUpdateBudget() {
  yield takeEvery(UPDATE_BUDGET, onUpdateBudget);
}

export function* watchDeleteBudget() {
  yield takeEvery(DELETE_BUDGET, onDeleteBudget);
}

export function* watchAddNewBudget() {
  yield takeEvery(ADD_NEW_BUDGET, onAddNewBudget);
}

function* budgetSaga() {
  yield all([
    fork(watchGetBudget),
    fork(watchDeleteBudget),
    fork(watchUpdateBudget),
    fork(watchAddNewBudget)
  ]);
}

export default budgetSaga;
